// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Action box */
.SettlementPortalLinkPopup_action_checkboxes_container__CL6lM {
  background-color: #f9f9f9;
  margin: auto;
  padding: 10px;
  border-radius: 5px;
}

.SettlementPortalLinkPopup_action_checkboxes_description__alvED {
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
}

.SettlementPortalLinkPopup_action_checkbox_list__mlN\\+q {
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 0;
}

/* Styling for each checkbox item */
.SettlementPortalLinkPopup_action_checkbox_item__yKqUv {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #555;
  cursor: pointer;
}

/* Styling for checkbox itself */
.SettlementPortalLinkPopup_action_checkbox__e5on6 {
  margin-right: 10px;
  color: #3f51b5;
}

/* Label for each checkbox */
.SettlementPortalLinkPopup_action_checkbox_label__t1JnF {
  font-weight: 500;
}

/* link selector component */
.SettlementPortalLinkPopup_link_type_selector__33l5U {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: space-around;
}

.SettlementPortalLinkPopup_button_component_container__qewPR {
  display: flex;
  flex-direction: column;
  padding: 15px 0;
  gap: 15px;
  background-color: #f9f9f9;
  border-radius: 5px;
  margin-bottom: 20px;
}

.SettlementPortalLinkPopup_button_input_container__dlFOy {
  padding: 0 20px;
  border-radius: 5px;
}

.SettlementPortalLinkPopup_color_picker_container__StyTk {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.SettlementPortalLinkPopup_color_picker_row__-iDik {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 5px;
  width: "150px";
}

.SettlementPortalLinkPopup_color_label__uLPzy {
  margin-right: 15px;
  text-align: left;
  color: #666;
  font-weight: normal;
}

.SettlementPortalLinkPopup_color_picker_block__nE34a {
  display: flex;
  align-items: center;
}

/* alternative text container */
.SettlementPortalLinkPopup_alternative_input_container__RlhEF {
  min-height: 128px;
  padding: 15px 20px 15px;
  background: #f9f9f9;
  margin-bottom: 20px;
  border-radius: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/SettlementPortalLinkPopup/SettlementPortalLinkPopup.module.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["/* Action box */\n.action_checkboxes_container {\n  background-color: #f9f9f9;\n  margin: auto;\n  padding: 10px;\n  border-radius: 5px;\n}\n\n.action_checkboxes_description {\n  font-size: 16px;\n  color: #333;\n  margin-bottom: 10px;\n}\n\n.action_checkbox_list {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  padding: 0;\n}\n\n/* Styling for each checkbox item */\n.action_checkbox_item {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  color: #555;\n  cursor: pointer;\n}\n\n/* Styling for checkbox itself */\n.action_checkbox {\n  margin-right: 10px;\n  color: #3f51b5;\n}\n\n/* Label for each checkbox */\n.action_checkbox_label {\n  font-weight: 500;\n}\n\n/* link selector component */\n.link_type_selector {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  justify-content: space-around;\n}\n\n.button_component_container {\n  display: flex;\n  flex-direction: column;\n  padding: 15px 0;\n  gap: 15px;\n  background-color: #f9f9f9;\n  border-radius: 5px;\n  margin-bottom: 20px;\n}\n\n.button_input_container {\n  padding: 0 20px;\n  border-radius: 5px;\n}\n\n.color_picker_container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.color_picker_row {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  margin-top: 5px;\n  width: \"150px\";\n}\n\n.color_label {\n  margin-right: 15px;\n  text-align: left;\n  color: #666;\n  font-weight: normal;\n}\n\n.color_picker_block {\n  display: flex;\n  align-items: center;\n}\n\n/* alternative text container */\n.alternative_input_container {\n  min-height: 128px;\n  padding: 15px 20px 15px;\n  background: #f9f9f9;\n  margin-bottom: 20px;\n  border-radius: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"action_checkboxes_container": `SettlementPortalLinkPopup_action_checkboxes_container__CL6lM`,
	"action_checkboxes_description": `SettlementPortalLinkPopup_action_checkboxes_description__alvED`,
	"action_checkbox_list": `SettlementPortalLinkPopup_action_checkbox_list__mlN+q`,
	"action_checkbox_item": `SettlementPortalLinkPopup_action_checkbox_item__yKqUv`,
	"action_checkbox": `SettlementPortalLinkPopup_action_checkbox__e5on6`,
	"action_checkbox_label": `SettlementPortalLinkPopup_action_checkbox_label__t1JnF`,
	"link_type_selector": `SettlementPortalLinkPopup_link_type_selector__33l5U`,
	"button_component_container": `SettlementPortalLinkPopup_button_component_container__qewPR`,
	"button_input_container": `SettlementPortalLinkPopup_button_input_container__dlFOy`,
	"color_picker_container": `SettlementPortalLinkPopup_color_picker_container__StyTk`,
	"color_picker_row": `SettlementPortalLinkPopup_color_picker_row__-iDik`,
	"color_label": `SettlementPortalLinkPopup_color_label__uLPzy`,
	"color_picker_block": `SettlementPortalLinkPopup_color_picker_block__nE34a`,
	"alternative_input_container": `SettlementPortalLinkPopup_alternative_input_container__RlhEF`
};
export default ___CSS_LOADER_EXPORT___;
